import * as yup from 'yup';
export const diplomaRules = {
  privacyPolicy: yup.bool().required('You need to accept the conditions').equals([true]),
  diplomaEquivalenceProvider: yup.string().required('You need to choose one of the options'),
  diplomaConfirmation: yup.bool().required('You must confirm that the above names should appear on the diploma as such.').equals([true]),
};

export const fellowshipDiplomaRules = {
  lengthOfStay: yup.string().matches(/^[0-9]+$/, 'Length of the stay must be a number').required('Enter your length of the stay').typeError('Length of the stay must be a number'),
  startDate: yup.date().required('Enter start date'),
  endDate: yup.date().required('Enter end date').test('is-valid-end-date', "End date can't be before start date", value => isValidDateEnd(value)),
  fellowshipHostCentre: yup.string().required('Choose your fellowship host centre'),
  hostInstitutionName: yup.string().required('Enter host instituion name').min(1).max(255),
  hostInstitutionAdress: yup.string().required('Enter host instituion adress').min(1).max(255),
  hostSupervisorFirstname: yup.string().required('Enter host supervisor first name').min(1).max(255),
  hostSupervisorLastname: yup.string().required('Enter host supervisor last name').min(1).max(255),
  hostSupervisorEmail: yup.string().required('Enter host supervisor e-mail address').email('Enter host supervisor e-mail in the format yourname@example.com'),
  briefDescription: yup.string().required('Enter brief description of fellowship goal').min(1).max(1000),
};

const isValidDateEnd = (date) => {
  if (date < fellowshipDiplomaRules.startDate) {
    return false;
  } else {
    return true;
  }
}
